import { TFunction } from "i18next";

export const getOTPCodeSentMessage = (otpType: string, locale: string, t: TFunction) => {
  if (locale === "th" && otpType === "SMS") {
    return t("{{otpType}} code sent", { otpType: "SMS OTP" });
  }
  return t("{{otpType}} code sent", { otpType });
};
